import React from 'react';
import {
  Box,
  Typography,
  Chip,
  Button,
} from '@mui/material';
import {
  Compare,
  Close as CloseIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export function CompareModeBanner({
  selectedFile,
  secondarySelectedFile,
  onExitCompareMode,
}) {
  const { t } = useTranslation(["files", "common"]);

  return (
    <Box
      sx={{
        bgcolor: 'info.main',
        color: 'white',
        p: 1.5,
        mb: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Compare />
        <Typography variant="body2" fontWeight="medium">
          {t("files:messages.compare_active")}
        </Typography>
        {selectedFile && (
          <Chip
            label={selectedFile.filename}
            size="small"
            sx={{ 
              bgcolor: 'info.dark', 
              color: 'white',
              maxWidth: 200,
              '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis' }
            }}
          />
        )}
        {secondarySelectedFile && (
          <>
            <Typography variant="body2">{t("files:vs")}</Typography>
            <Chip
              label={secondarySelectedFile.filename}
              size="small"
              sx={{ 
                bgcolor: 'warning.main', 
                color: 'white',
                maxWidth: 200,
                '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis' }
              }}
            />
          </>
        )}
      </Box>
      <Button
        size="small"
        variant="outlined"
        color="gray.100"
        startIcon={<CloseIcon />}
        onClick={onExitCompareMode}
        sx={{
          borderColor: 'white',
          color: 'white',
          '&:hover': {
            borderColor: 'white',
            bgcolor: 'rgba(255, 255, 255, 0.1)',
          },
        }}
      >
        {t("files:exit_compare")}
      </Button>
    </Box>
  );
}